<template>
  <Dialog ref="dialog"
          width="50%"
          icon="fas fa-box"
          @confirm="verify"
          :show-confirm="countSocToLoad < 1"
          title="Cargar subordenes">
    <div v-if="countSocToLoad < 1">
      <el-input type="textarea"
                :rows="3"
                placeholder="124005957777, 124005958888 ..."
                v-model="textareaSocs">
      </el-input>
    </div>
    <div v-else class="progress">
      <p class="indicator">
        <span>total a verificar: </span>{{ countSocToLoad }}
      </p>
      <el-progress :color="color"
                   :text-inside="true"
                   :stroke-width="20"
                   :percentage="loadPercentage"/>
      <p class="indicators">
        <i :class="loadIcon"/> {{ msgLoad }}
        <span class="in-load">
            verificadas: <span class="verified">{{countVerified}}</span> /
            no encontradas: <span class= "not-found">{{countNotFound}}</span>
          </span>
      </p>
    </div>
  </Dialog>
</template>

<script>
import { apiRequest } from '../../../../backend/vue-axios/axios';
import Dialog from '../../base/Dialog.vue';

export default {
  name: 'SuborderAdd',
  components: {
    Dialog,
  },
  props: {
    value: {
      type: Array,
      default() {
        return [];
      },
    },
  },
  data() {
    return {
      msgLoad: 'Procesando . . .',
      countSocToLoad: 0,
      countCurrentSocLoad: 0,
      countVerified: 0,
      countNotFound: 0,
      maxPerBatch: 500,
      list: this.value,
      textareaSocs: '',
      color: '#AAD500',
    };
  },
  watch: {
    list() {
      this.$emit('input', this.list);
    },
    value() {
      this.list = this.value;
    },
    countCurrentSocLoad(value) {
      this.msgLoad = `Solicitando verificación: ${value} de ${this.countSocToLoad}`;
      if (value === this.countSocToLoad) this.$refs.dialog.loading(false);
      if (this.loadPercentage === 100) this.msgLoad = 'Verificación finalizada';
    },
  },
  filters: {
    len(data) {
      return data.length;
    },
  },
  methods: {
    verify() {
      const newSocs = this.clearInput(this.textareaSocs)
        .filter(ns => !this.list.map(s => s.suborder).includes(ns));
      this.list = newSocs
        .map(s => ({ suborder: s, verified: false, sectors: [] }))
        .concat(this.list);
      this.loadOnlySocs(newSocs);
      this.textareaSocs = '';
    },
    clearInput(textInput) {
      return [...new Set(textInput.trim()
        .split(/\s*[,\n\r][\s\n\r]*/gimu)
        .filter(s => s.match(/^[0-9]{6,20}$/gim))
        .map(s => parseInt(s, 10)))];
    },
    loadOnlySocs(newSocs) {
      if (newSocs.length > 0) {
        const partialNewSocs = [];
        this.countSocToLoad = newSocs.length;
        while (newSocs.length) partialNewSocs.push(newSocs.splice(0, this.maxPerBatch));
        this.loadBatch(partialNewSocs, 5000);
      } else {
        this.$refs.dialog.loading(false);
        this.$notify({
          type: 'warning',
          title: 'Error al cargas las subordenes',
          message: 'No son válidas o están repetidas',
        });
      }
    },
    loadBatch(batch, delay) {
      const newBatch = batch.splice(0, 2);
      newBatch.forEach(async (request) => {
        await this.verifyPartial(request).then(async (socs) => {
          await this.loadPercent(socs);
        });
      });
      if (batch.length > 0) {
        setTimeout(() => { this.loadBatch(batch, delay - (delay / 10)); }, delay);
      }
    },
    loadPercent(socs) {
      const totalNotFound = socs.filter(s => this.notFound(s)).length;
      this.countVerified += socs.length - totalNotFound;
      this.countNotFound += totalNotFound;
      const progress = [];
      while (socs.length) progress.push(socs.splice(0, 50).length);
      for (let i = 0; i < progress.length; i += 1) {
        setTimeout(() => { this.countCurrentSocLoad += progress[i]; }, 25);
      }
    },
    verifyPartial(partialNewSocs) {
      return new Promise((resolve) => {
        apiRequest({
          module: 'planning',
          service: 'verify_suborders',
          params: {
            suborders: partialNewSocs,
          },
        }).then((response) => {
          resolve(response.data);
          response.data.forEach((val) => {
            Object.entries(val).forEach(([k, v]) => {
              this.list.find(s => s.suborder === val.suborder)[k] = v;
            });
            this.list.find(s => s.suborder === val.suborder).verified = true;
            if (val.last_state === -1 && val.current_do !== -1) {
              this.list.find(s => s.suborder === val.suborder).last_state = 1;
              this.list.find(s => s.suborder === val.suborder).last_state_name = 'Digitado';
            }
          });
        }).catch(() => {
          this.countNotFound += partialNewSocs.length;
          this.countCurrentSocLoad += partialNewSocs.length;
          this.list = this.list.filter(s => !partialNewSocs.includes(s.suborder));
          this.$notify({
            type: 'error',
            title: 'Error al cargas las subordenes',
            message: 'Vuelva a intentarlo más tardes',
          });
        });
      });
    },
    notFound(soc) {
      return soc.current_do === -1;
    },
    open() {
      this.msgLoad = 'Procesando . . .';
      this.countSocToLoad = 0;
      this.countCurrentSocLoad = 0;
      this.countVerified = 0;
      this.countNotFound = 0;
      this.$refs.dialog.visible(true);
    },
  },
  computed: {
    loadPercentage() {
      return this.countSocToLoad > 0
        ? Math.round((this.countCurrentSocLoad / this.countSocToLoad) * 100) : 0;
    },
    loadIcon() {
      return this.loadPercentage === 100 ? 'el-icon-loading' : 'el-icon-folder-checked';
    },
  },
};
</script>

<style lang="scss" scoped>
  .loading {
    text-align: center;
    .el-icon-loading {
      font-size: 32px;
      color: $fb-green;
    }
  }
  .progress {
    margin: 14px;
    .indicators {
      height: 18px;
      font-size: 13px;
      font-weight: 300;
      text-transform: lowercase;
      margin: 4px 2px;
      i {
        font-weight: 900;
        margin-right: 3px;
        color: $fb-green;
      }
      .in-load {
        float: right;
        .verified { color: $fb-blue; }
        .not-found { color: $fb-red; }
        .split, .verified, .not-found { font-weight: 600; }
      }
    }
    .indicator {
      font-size: 13px;
      font-weight: 600;
      margin: 0 0 4px 3px;
      span { font-weight: 300; }
      text-transform: lowercase;
    }
  }
</style>
